/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 * Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React examples
import DataTable from "examples/Tables/DataTable";

//React Hooks and Others
import { Link, useNavigate } from "react-router-dom";
import { CircularProgress, Icon, Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import ComponentsPrivatization from "config/component_privatization";
import { style_icon } from "helpers/global_vars";
import { useRedirectForm } from "hooks/useRedirectForm";
import { AUXILIAR_DOCENTE, COORDINADOR_DOCENTE } from "roles";
import { useCallback, useEffect, useState } from "react";
import {
  useDeleteGrupoEscolarMutation,
  useGetCarrerasPorGrupoQuery,
} from "services";
import usePagination from "hooks/usePagination";
import { setCicloActivo } from "../../../../slices";
import { useDispatch } from "react-redux";
import useModalHandler from "hooks/useModalHandler";
import HistorialComponent from "./components/descarga_historial";
import { calificaciones } from "slices";
import { useSelector } from "react-redux";
import NewGrupoEscolar from "layouts/escuela/ModalCreate/NewGrupoEscolar/newGrupoEscolar";
import PromoverGrupoEscolar from "layouts/escuela/ModalCreate/PromoverGrupo/promoverGrupo";
import NewDistributionToGroup from "layouts/escuela/ModalCreate/NewDistributionToGroup/NewDistributionToGroup";

function DataTableGrupos({ tableHeader }) {
  const { cicloSeleccionado } = useSelector(calificaciones);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!cicloSeleccionado)
    return (
      <MDBox
        mt={5}
        width={"100%"}
        display={"flex"}
        py={5}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
      </MDBox>
    );

  const {
    offset,
    setOffset,
    limit,
    handleNext,
    handlePrevious,
    busqueda,
    setBusqueda,
  } = usePagination();

  const { open, handleOpen, handleClose } = useModalHandler();
  const {
    open: openModalGrupo,
    handleOpen: handleOpenModalGrupoBase,
    handleClose: handleCloseModalGrupoBase,
  } = useModalHandler();
  const {
    open: openModalPromover,
    handleOpen: handleOpenModalPromover,
    handleClose: handleCloseModalPromover,
  } = useModalHandler();
  const {
    open: openModalDistribucion,
    handleOpen: handleOpenModalDistribucion,
    handleClose: handleCloseModalDistribucionBase,
  } = useModalHandler();

  const [selectedGrupoId, setSelectedGrupoId] = useState(null);
  const [selectedDistribucionGrupoId, setSelectedDistribucionGrupoId] = useState(null);

  const handleOpenModalGrupo = (id = null) => {
    setSelectedGrupoId(id);
    handleOpenModalGrupoBase();
  };

  const handleCloseModalGrupo = () => {
    handleCloseModalGrupoBase();
    setSelectedGrupoId(null);
  };

  const handleOpenModalDistribucionAction = (id) => {
    setSelectedDistribucionGrupoId(id);
    handleOpenModalDistribucion();
  };

  const handleCloseModalDistribucion = () => {
    handleCloseModalDistribucionBase();
    setSelectedDistribucionGrupoId(null);
  };

  useEffect(() => {
    if (cicloSeleccionado?.activo)
      dispatch(setCicloActivo(cicloSeleccionado?.id));
  }, [cicloSeleccionado?.id]);

  const {
    data: gruposEscolares_data,
    isError: isErrorG,
    isLoading: isLoadingG,
    error: errorG,
    isFetching,
  } = useGetCarrerasPorGrupoQuery(
    {
      filter_params: {
        ordering:
          "ciclo_interno__numero_de_ciclo,grupo__identificador,ciclo_interno__carrera__nombre",
        limit: limit,
        offset: offset,
        ciclo: cicloSeleccionado?.id,
        buscar: busqueda,
        query:
          "{id,no_estudiantes,url,grupo{id,identificador},ciclo_interno{numero_de_ciclo,carrera{nombre,plan_de_estudio}}}",
      },
      shape: {
        id: "id",
        url: "url",
        grupo_id: "grupo.id",
        identificador: "grupo.identificador",
        carrera: "ciclo_interno.carrera.nombre",
        semestre: "ciclo_interno.numero_de_ciclo",
        plan_de_estudio: "ciclo_interno.carrera.plan_de_estudio",
        no_estudiantes: "no_estudiantes",
      },
    },
    {
      refetchOnReconnect: true,
    },
  );

  //constantes para manejar la paginacion
  const dataRest = gruposEscolares_data?.results
    ? gruposEscolares_data.results
    : gruposEscolares_data;
  const countTotal = gruposEscolares_data?.count;
  const previous = gruposEscolares_data?.previous;
  const next = gruposEscolares_data?.next;

  const [
    deleteGrupoEscolar,
    {
      isSuccess: isSuccessD,
      isLoading: isLoadingD,
      isError: isErrorD,
      error: errorD,
    },
  ] = useDeleteGrupoEscolarMutation();

  const dataTableDistribucion = {
    columns: [
      {
        Header: "Semestre",
        accessor: "semestre",
        width: "10%",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Grupo",
        accessor: "identificador",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Carrera",
        accessor: "carrera",
        Cell: ({ value, row: { original } }) => {
          return value
            ? value + " " + original.plan_de_estudio
            : "-------------";
        },
      },
      {
        Header: "No. Estudiantes",
        accessor: "no_estudiantes",
        width: "10%",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Acciones",
        accessor: "actions",
        width: "1%",
        Cell: ({ row }) => {
          const { original } = row;
          return (
            <MDBox display="flex">
              <MDBox px={0.2}>
                <Tooltip
                  placement="top"
                  title="Ver los profesores y estudiantes asociados a este grupo (Puede acceder a esta funncionalidad con doble click en cualquier parte de la fila)"
                >
                  <Icon
                    style={style_icon}
                    onClick={() => handleClickShow(original)}
                    fontSize="small"
                  >
                    find_in_page
                  </Icon>
                </Tooltip>
              </MDBox>
              <ComponentsPrivatization
                permitted={[COORDINADOR_DOCENTE, AUXILIAR_DOCENTE]}
              >
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Distribuir un profesor con su asignatura correspondiente a este Grupo y agregar varios estudiantes al grupo"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickAsignar(original.id)}
                      fontSize="small"
                    >
                      group_add
                    </Icon>
                  </Tooltip>
                </MDBox>
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Editar la información del grupo"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickEdit(original)}
                      fontSize="small"
                    >
                      edit
                    </Icon>
                  </Tooltip>
                </MDBox>
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Eliminar el grupo del listado"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() =>
                        handleClickErase(
                          original.grupo_id,
                          original.identificador,
                        )
                      }
                      fontSize="small"
                    >
                      remove_circle
                    </Icon>
                  </Tooltip>
                </MDBox>
              </ComponentsPrivatization>
            </MDBox>
          );
        },
      },
    ],

    rows: dataRest ?? [],
  };

  useRedirectForm(
    isLoadingG,
    null,
    isErrorG,
    errorG,
    "Hubo problemas para cargar la información",
    `/ciclos/${cicloSeleccionado?.nombre}/grupos`,
  );

  useRedirectForm(
    isLoadingD,
    isSuccessD,
    isErrorD,
    errorD,
    "Grupo eliminado",
    `/ciclos/${cicloSeleccionado?.nombre}/grupos`,
  );

  const handleClickErase = (id, nombre) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: `¡Si eliminas el grupo: "${nombre}", la acción no se podrá revertir! Esto eliminara todas las asociaciones de estudiantes, profesores y notas al mismo, hagalo bajo su propia responsibilidad.`,
      icon: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteGrupoEscolar(id);
      }
    });
  };

  const handleClickEdit = (el) => {
    handleOpenModalGrupo(el.id);
  };

  const handleClickAsignar = useCallback(
    (id) => {
      handleOpenModalDistribucionAction(id);
    },
    []
  );

  const handleClickShow = useCallback(
    (el) => {
      navigate(
        `/ciclos/${cicloSeleccionado?.nombre}/grupos/grupo/${el.id}/ciclo/${cicloSeleccionado?.id}`,
      );
    },
    [cicloSeleccionado?.nombre, cicloSeleccionado?.id],
  );

  const actions = (
    <MDBox display="flex" gap={2} alignItems="center">
      <ComponentsPrivatization
        permitted={[COORDINADOR_DOCENTE, AUXILIAR_DOCENTE]}
      >
        <MDBox display="flex" gap={1} alignItems="center">
          <Tooltip placement="top" title="Pedir historial de notas de grupos">
            <MDButton
              variant={"gradient"}
              color={"secondary"}
              size="medium"
              onClick={handleOpen}
              circular
              iconOnly
            >
              <Icon>history</Icon>
            </MDButton>
          </Tooltip>
          <Tooltip
            placement="top"
            title="Crear nuevo grupo y asociarlo a un ciclo interno pero con los estudiantes de un grupo anterior"
          >
            <MDButton
              variant="contained"
              color="dark"
              size="medium"
              onClick={handleOpenModalPromover}
            >
              Clonar
            </MDButton>
          </Tooltip>
          <Tooltip
            placement="top"
            title="Crear nuevo grupo y asociarlo a un ciclo interno de una carrera ya existente"
          >
            <MDButton
              variant="contained"
              color="accent"
              size="medium"
              onClick={() => handleOpenModalGrupo()}
            >
              Nuevo
            </MDButton>
          </Tooltip>
        </MDBox>
      </ComponentsPrivatization>
    </MDBox>
  );

  return (
    <MDBox pt={0} pb={3}>
      {open && (
        <HistorialComponent
          open={open}
          handleClose={handleClose}
          ciclo_id={cicloSeleccionado?.id}
        />
      )}
      {openModalGrupo && (
        <NewGrupoEscolar
          open={openModalGrupo}
          handleClose={handleCloseModalGrupo}
          id={selectedGrupoId}
        />
      )}
      {openModalPromover && (
        <PromoverGrupoEscolar
          open={openModalPromover}
          handleClose={handleCloseModalPromover}
        />
      )}
      {openModalDistribucion && (
        <NewDistributionToGroup
          open={openModalDistribucion}
          handleClose={handleCloseModalDistribucion}
          id={selectedDistribucionGrupoId}
        />
      )}
      <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
        {isLoadingG || isFetching ? (
          <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
        ) : (
          <DataTable
            tableHeader={tableHeader}
            actions={actions}
            table={dataTableDistribucion}
            canSearch
            doubleClick={handleClickShow}
            paginationApi
            countTotal={countTotal}
            next={next}
            previous={previous}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            setBusqueda={setBusqueda}
            offset={offset}
            setOffset={setOffset}
          />
        )}
      </MDBox>
    </MDBox>
  );
}

DataTableGrupos.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableGrupos;
